import React from 'react';
import style from './DiscoveryCardBottomInfoBlock.scss';
import { usePortletTranslations } from 'js/components/system/Portlet';
import classNames from '../../Details/classNames';

export const DiscoveryCardBottomInfoBlock = ({ fakeState, joined, missions }) => {

    const t = usePortletTranslations();
    const joinedButton = {
        text: 'joined',
        style: 'joinedButton'
    };
    const readmoreButton = {
        text: 'readMore',
        style: 'readMoreButton'
    };

    const mapFakeStateToText = {
        discoveryActive: {
            leftButton: joinedButton,
            rightButton: readmoreButton
        },
        discoveryUpcomingJoined: {
            leftButton: joinedButton,
            rightButton: readmoreButton
        },
        discoveryUpcomingNotJoined: {
            leftButton: readmoreButton
        },
        discoveryAvailable: {
            leftButton: readmoreButton
        },
        discoveryFinished: {
            leftButton: {
                text: 'viewResults',
                style: 'viewResultsButton'
            }
        },
        discoveryCompleted: {
            leftButton: {
                text: missions ? 'viewCampaign' : 'viewLeaderboard',
                style: 'viewResultsButton'
            }
        },
        discoveryCampaignCompleted: {
            leftButton: {
                text: 'viewCampaign',
                style: 'viewResultsButton'
            }
        }
    };

    const transformFakeState = (state, isJoined) => {
        if (state === 'discoveryComingSoon') {
            return isJoined ? 'discoveryUpcomingJoined' : 'discoveryUpcomingNotJoined';
        }
        if (state === 'discoveryFinished' && missions) {
            return 'discoveryCampaignCompleted';
        }
        return state;
    };

    const restyleLeftButton = (buttonObj) => {
        if ((fakeState === 'discoveryActive' || fakeState === 'discoveryComingSoon') && t(buttonObj.text).length > 9) {
            buttonObj.text = `${t(buttonObj.text).substring(0, 8)}..`;
            buttonObj.style = 'joinedButton_small';
        } else if ((fakeState === 'discoveryFinished' || fakeState === 'discoveryCompleted') && t(buttonObj.text).length > 20) {
            buttonObj.style = 'viewResultsButton_small';
            buttonObj.text = t(buttonObj.text);
        } else {
            buttonObj.text = t(buttonObj.text);
        }
    };
    const restyleRightButton = (buttonObj) => {
        if (t(buttonObj.text).length > 20) {
            buttonObj.style = 'readMoreButton_small';
        }
    };

    const { leftButton, rightButton } = mapFakeStateToText[transformFakeState(fakeState, joined)];
    restyleLeftButton(leftButton);
    if (rightButton) {
        restyleRightButton(rightButton);
    }
    return (
        <div className={leftButton && rightButton ? style.container_items_centered : style.container_item} >
            <div className={classNames(style[leftButton.style],
                { [style.bothButtonsEnabled]: leftButton && rightButton })}>{leftButton.text}</div>
            {rightButton && <div className={classNames(style[rightButton.style],
                { [style.bothButtonsEnabled]: leftButton && rightButton })}>{t(rightButton.text)}</div>}
        </div>
    );
};
